import Vue from 'vue'
import VueResource from 'vue-resource'
import store from '../store'
import message from './msg_srv'
import { CONFIG } from '../config'
Vue.use(VueResource)

// 封装基础http请求方法
var getApi = function (url, params, sucCallback, failCallback) {
    let newPF = params ? params.platform : undefined, newParams = Object.assign({}, params);
    var getUrl = CONFIG.api_url + url,
        pathName = window.location.pathname;
    var getParams = Object.assign(CONFIG.platform_params, newParams);
    if(pathName.indexOf('embedded') != -1) {
        // embedded客户端的嵌入式页面不添加用户信息参数
        getParams = Object.assign(getParams, store.state.embedded.queryData);
        // embedded客户端的嵌入式页面获取商品列表添加platform
        if((url == '/pay/productList' || url == '/ai/config') && newPF) {
            getParams = Object.assign(getParams, {platform: newPF});
        }
    }else {
        if(url != '/user/check') {
            // 非登录接口要添加用户信息参数:::uid 
            getParams = store.state.userData && store.state.userData.token ? Object.assign(getParams, {
                token: store.state.userData.token
            }) : getParams;
        }
    }
    // if(store.state.platform !== 0) {
    //     getParams = Object.assign(getParams, {platform: store.state.platform});
    // }

    return new Promise((resolve, reject) => {
        Vue.http.get(getUrl, { params: getParams }, { emulateJSON: true }).then((response) => {
            if(response.data.status_code == 200) {
                if (sucCallback) {
                    sucCallback(response.data.data)
                }
                resolve();
            }else {
                // 提示错误信息
                if(url.indexOf('pipan') != -1) {
                    AppFate.$toast(response.data.message || '请求失败，请稍后重试');
                }
                if (failCallback) { 
                    failCallback(response.data)
                }
                if (response.data.status_code) {
                    console.error("请求失败", message[response.data.status_code]);
                }
                reject();
            }
        });
    }).catch((err) => {
        console.error("请求失败::::::", err);
    });
}

// 注册事件，方便调用
var API = {
    // banner:获取banner
    getBanner: function (params, suc_cb, fail_cb) { getApi('/banner/allList', params, suc_cb, fail_cb) },
    // 登录方法:手机号登录
    userLogin: function (params, suc_cb, fail_cb) { getApi('/login/user', params, suc_cb, fail_cb) },
    // 登录:发送验证码
    sendLoginCode: function (params, suc_cb, fail_cb) { getApi('/sendSms', params, suc_cb, fail_cb) },
    // 获取用户信息
    getUserInfo: function (params, suc_cb, fail_cb) { getApi('/user', params, suc_cb, fail_cb) },
    // 绑定手机号
    bindUser: function (params, suc_cb, fail_cb) { getApi('/user/bindUser', params, suc_cb, fail_cb) },
    // 检查是否有设密码
    havepwd: function (params, suc_cb, fail_cb) { getApi('/user/havepwd', params, suc_cb, fail_cb) },
    // 修改密码
    changepwd: function (params, suc_cb, fail_cb) { getApi('/user/changepwd', params, suc_cb, fail_cb) },
    // 检查token是否有效方法
    checkLogin: function (params, suc_cb, fail_cb) { getApi('/user/check', params, suc_cb, fail_cb) },
    // 登录方法
    thirdLogin: function (params, suc_cb, fail_cb) { getApi('/login/thirdLogin', params, suc_cb, fail_cb) },
    // 活动:获取活动信息
    getActivityInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/activity/info', params, suc_cb, fail_cb) },
    // 获取八字记录信息
    importSqg: function (params, suc_cb, fail_cb) { getApi('/muhuo/sqg', params, suc_cb, fail_cb) },
    // 获取分组、强弱、命局、药基础数据
    getUserType: function (params, suc_cb, fail_cb) { getApi('/muhuo/getUserType', params, suc_cb, fail_cb) },
    // 获取八字信息
    getDetailInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/info', params, suc_cb, fail_cb) },
    // 获取八字记录信息
    getAllList: function (params, suc_cb, fail_cb) { getApi('/muhuo/allList', params, suc_cb, fail_cb) },
    // 获取八字记录最近浏览列表
    getRecently: function (params, suc_cb, fail_cb) { getApi('/muhuo/getRecently', params, suc_cb, fail_cb) },
    // 增加排盘
    addPaiPan: function (params, suc_cb, fail_cb) { getApi('/muhuo/add', params, suc_cb, fail_cb) },
    // 修改排盘
    updatePaiPan: function (params, suc_cb, fail_cb) { getApi('/muhuo/update', params, suc_cb, fail_cb) },
    // 删除排盘
    deleteRecord: function (params, suc_cb, fail_cb) { getApi('/muhuo/del', params, suc_cb, fail_cb) },
    // 批量修改起盘分组
    changeGroup: function (params, suc_cb, fail_cb) { getApi('/muhuo/changegroup', params, suc_cb, fail_cb) },
    // 批量修改起盘最近浏览时间
    changeGlanceTime: function (params, suc_cb, fail_cb) { getApi('/muhuo/changeglancetime', params, suc_cb, fail_cb) },
    // 获取列表分享的盘数据
    getShareData: function (params, suc_cb, fail_cb) { getApi('/muhuo/getShare', params, suc_cb, fail_cb) },
    // 获取其他分享数据（批盘，反馈，反馈对照）
    getOtherShareData: function (params, suc_cb, fail_cb) { getApi('/muhuo/getOtherShare', params, suc_cb, fail_cb) },
    // 获取其他分享数据新:批盘
    getOtherShareDataNew: function (params, suc_cb, fail_cb) { getApi('/muhuo/getOtherShareNew', params, suc_cb, fail_cb) },
    // 保存分享（批盘，对照，反馈）
    saveOtherShareData: function (params, suc_cb, fail_cb) { getApi('/muhuo/saveOtherShare', params, suc_cb, fail_cb) },
    // 获取他人批盘:列表数据
    getOtherShareDataList: function (params, suc_cb, fail_cb) { getApi('/muhuo/getOtherListNew', params, suc_cb, fail_cb) },
    // 修改他人批盘:（分享、对照）标题
    editOtherShareData: function (params, suc_cb, fail_cb) { getApi('/muhuo/editOtherList', params, suc_cb, fail_cb) },
    // 删除他人批盘:（反馈、对照）
    deleteOtherShareData: function (params, suc_cb, fail_cb) { getApi('/muhuo/delOtherList', params, suc_cb, fail_cb) },
    // 获取八字的统计数据
    getBaziNum: function (params, suc_cb, fail_cb) { getApi('/muhuo/getBaziNum', params, suc_cb, fail_cb) },
    // 获取批盘数据
    getPiPanData: function (params, suc_cb, fail_cb) { getApi('/muhuo/pipan/info', params, suc_cb, fail_cb) },
    // 获取批盘数据
    getPiPanDataNew: function (params, suc_cb, fail_cb) { getApi('/muhuo/pipan/infoNew', params, suc_cb, fail_cb) },
    // 修改批盘数据
    updatePiPan: function (params, suc_cb, fail_cb) { getApi('/muhuo/pipan/update', params, suc_cb, fail_cb) },
    // 获取分组列表
    getGroupList: function (params, suc_cb, fail_cb) { getApi('/muhuo/group/allList', params, suc_cb, fail_cb) },
    // 增加分组
    addGroup: function (params, suc_cb, fail_cb) { getApi('/muhuo/group/add', params, suc_cb, fail_cb) },
    // 修改分组
    updateGroup: function (params, suc_cb, fail_cb) { getApi('/muhuo/group/update', params, suc_cb, fail_cb) },
    // 删除分组
    deleteGroup: function (params, suc_cb, fail_cb) { getApi('/muhuo/group/del', params, suc_cb, fail_cb) },
    // 获取标签列表
    getLabelList: function (params, suc_cb, fail_cb) { getApi('/muhuo/label/allList', params, suc_cb, fail_cb) },
    // 增加标签
    addLabel: function (params, suc_cb, fail_cb) { getApi('/muhuo/label/add', params, suc_cb, fail_cb) },
    // 修改标签
    updateLabel: function (params, suc_cb, fail_cb) { getApi('/muhuo/label/update', params, suc_cb, fail_cb) },
    // 删除标签
    deleteLabel: function (params, suc_cb, fail_cb) { getApi('/muhuo/label/del', params, suc_cb, fail_cb) },
    // 获取命局列表
    getSituationList: function (params, suc_cb, fail_cb) { getApi('/muhuo/situation/allList', params, suc_cb, fail_cb) },
    // 增加命局
    addSituation: function (params, suc_cb, fail_cb) { getApi('/muhuo/situation/add', params, suc_cb, fail_cb) },
    // 修改命局
    updateSituation: function (params, suc_cb, fail_cb) { getApi('/muhuo/situation/update', params, suc_cb, fail_cb) },
    // 删除命局
    deleteSituation: function (params, suc_cb, fail_cb) { getApi('/muhuo/situation/del', params, suc_cb, fail_cb) },
    // 获取强弱列表
    getStrongList: function (params, suc_cb, fail_cb) { getApi('/muhuo/strong/allList', params, suc_cb, fail_cb) },
    // 增加强弱
    addStrong: function (params, suc_cb, fail_cb) { getApi('/muhuo/strong/add', params, suc_cb, fail_cb) },
    // 修改强弱
    updateStrong: function (params, suc_cb, fail_cb) { getApi('/muhuo/strong/update', params, suc_cb, fail_cb) },
    // 删除强弱
    deleteStrong: function (params, suc_cb, fail_cb) { getApi('/muhuo/strong/del', params, suc_cb, fail_cb) },
    // 获取药列表
    getMedicineList: function (params, suc_cb, fail_cb) { getApi('/muhuo/medicine/allList', params, suc_cb, fail_cb) },
    // 增加药
    addMedicine: function (params, suc_cb, fail_cb) { getApi('/muhuo/medicine/add', params, suc_cb, fail_cb) },
    // 修改药
    updateMedicine: function (params, suc_cb, fail_cb) { getApi('/muhuo/medicine/update', params, suc_cb, fail_cb) },
    // 删除药
    deleteMedicine: function (params, suc_cb, fail_cb) { getApi('/muhuo/medicine/del', params, suc_cb, fail_cb) },
    // 获取热门论盘列表
    getHotLunPanList: function (params, suc_cb, fail_cb) { getApi('/muhuo/lunpan/hotList', params, suc_cb, fail_cb) },
    // 获取已保存的论盘列表
    getMySavedLunPanList: function (params, suc_cb, fail_cb) { getApi('/muhuo/lunpan/myList', params, suc_cb, fail_cb) },
    // 获取我参与的论盘列表
    getMyJoinedLunPanList: function (params, suc_cb, fail_cb) { getApi('/muhuo/lunpan/myJoin', params, suc_cb, fail_cb) },
    // 获取论盘列表
    getLunPanList: function (params, suc_cb, fail_cb) { getApi('/muhuo/lunpan/allList', params, suc_cb, fail_cb) },
    // 增加(保存)论盘
    addLunPan: function (params, suc_cb, fail_cb) { getApi('/muhuo/lunpan/add', params, suc_cb, fail_cb) },
    // 删除论盘
    deleteLunPan: function (params, suc_cb, fail_cb) { getApi('/muhuo/lunpan/del', params, suc_cb, fail_cb) },
    // 修改更新论盘
    updateLunPan: function (params, suc_cb, fail_cb) { getApi('/muhuo/lunpan/update', params, suc_cb, fail_cb) },
    // 获取论盘消息记录
    getLunPanMsgList: function (params, suc_cb, fail_cb) { getApi('/muhuo/lunpan/getMsgList', params, suc_cb, fail_cb) },
    // 获取参与论盘的所有人/@我的/回复我的
    getLunPanRoomConfig: function (params, suc_cb, fail_cb) { getApi('/muhuo/lunpan/getRoomConfig', params, suc_cb, fail_cb)},
    // 设置@已读
    setLunPanAtMeRead: function (params, suc_cb, fail_cb) { getApi('/muhuo/lunpan/readTouchMe', params, suc_cb, fail_cb)},
    // 基础配置:获取基础配置信息
    getSettingConfig: function (params, suc_cb, fail_cb) { getApi('/muhuo/config/allList', params, suc_cb, fail_cb) },
    // 基础配置:更新基础配置信息
    updateSettingConfig: function (params, suc_cb, fail_cb) { getApi('/muhuo/config/update', params, suc_cb, fail_cb) },
    // 基础配置:获取微信jssdk配置信息
    getWeixinSdkConfig: function (params, suc_cb, fail_cb) { getApi('/muhuo/config/weixinSdk', params, suc_cb, fail_cb) },
    // 基础配置:自定义扩展配置获取
    getAllExtList: function (params, suc_cb, fail_cb) { getApi('/muhuo/config/allExtList', params, suc_cb, fail_cb) },
    // 基础配置:自定义扩展配置修改或者增加
    updateExtList: function (params, suc_cb, fail_cb) { getApi('/muhuo/config/updateExt', params, suc_cb, fail_cb) },
    // 基础配置:提示数据获取
    getConfigTips: function (params, suc_cb, fail_cb) { getApi('/muhuo/config/tips', params, suc_cb, fail_cb) },
    // 基础配置:获取配置的json数据
    getConfigJson: function (params, suc_cb, fail_cb) { getApi('/muhuo/config/json', params, suc_cb, fail_cb) },
    // 支付:捐赠:获取商品列表
    getProductList: function (params, suc_cb, fail_cb) { getApi('/pay/productList', params, suc_cb, fail_cb) },
    // 支付:捐赠:下单
    createDonateOrder: function (params, suc_cb, fail_cb) { getApi('/pay/createOrder', params, suc_cb, fail_cb) },
    // 捐赠:获取加油人数
    getDonateSupport: function (params, suc_cb, fail_cb) { getApi('/muhuo/support/getSupport', params, suc_cb, fail_cb) },
    // 捐赠:加油
    setDonateSupport: function (params, suc_cb, fail_cb) { getApi('/muhuo/support/setSupport', params, suc_cb, fail_cb) },
    // 捐赠:留下联系方式
    setContact: function (params, suc_cb, fail_cb) { getApi('/muhuo/support/setContact', params, suc_cb, fail_cb) },
    // AI测算:获取基础配置
    getAIConfig: function (params, suc_cb, fail_cb) { getApi('/ai/config', params, suc_cb, fail_cb) },
    // 获取测算信息:根据id
    getAIDetailInfo: function (params, suc_cb, fail_cb) { getApi('/ai/getInfo', params, suc_cb, fail_cb) },
    // 获取测算强弱信息:根据id
    getAIStrongInfo: function (params, suc_cb, fail_cb) { getApi('/ai/getStrong', params, suc_cb, fail_cb) },
    // AI测算:获取显示时间
    getShowTime: function (params, suc_cb, fail_cb) { getApi('/ai/getShowTime', params, suc_cb, fail_cb) },
    // AI测算:上报显示时间
    upShowTime: function (params, suc_cb, fail_cb) { getApi('/ai/upShowTime', params, suc_cb, fail_cb) },
    // AI测算:返回时候检查弹框信息
    setLeave: function (params, suc_cb, fail_cb) { getApi('/ai/setLeave', params, suc_cb, fail_cb) },
    // AI测算:648VIP场景触发上报
    addOtherShow: function (params, suc_cb, fail_cb) { getApi('/ai/addOtherShow', params, suc_cb, fail_cb) },
    // AI测算:获取测算
    getAIInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/getAiInfo', params, suc_cb, fail_cb) },
    // AI测算:获取天赋
    getAiCharacter: function (params, suc_cb, fail_cb) { getApi('/muhuo/getAiCharacter', params, suc_cb, fail_cb) },
    // AI测算:使用免费机会解锁性格
    useFree: function (params, suc_cb, fail_cb) { getApi('/muhuo/useFree', params, suc_cb, fail_cb) },
    // 年运:获取性格数据
    getYearCharacter: function (params, suc_cb, fail_cb) { getApi('/muhuo/year/getYearCharacter', params, suc_cb, fail_cb) },
    // 年运:性格解锁上报
    setCharacterUnlock: function (params, suc_cb, fail_cb) { getApi('/muhuo/year/setCharacterUnlock', params, suc_cb, fail_cb) },
    // 年运:获取年运信息
    getYearInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/year/getInfo', params, suc_cb, fail_cb) },
    // 年运:获取年运信息
    freeUnlockYear: function (params, suc_cb, fail_cb) { getApi('/muhuo/year/freeUnlockYear', params, suc_cb, fail_cb) },
    // 支付:下单
    createOrder: function (params, suc_cb, fail_cb) { getApi('/pay/createOrder', params, suc_cb, fail_cb) },
    // 百科:热门百科
    getHotList: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/getHotList', params, suc_cb, fail_cb) },
    // 百科:最新百科
    getNewList: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/getNewList', params, suc_cb, fail_cb) },
    // 百科:我的百科
    getMyList: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/getMyBaike', params, suc_cb, fail_cb) },
    // 百科:最近浏览百科
    getGlanceList: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/getGlanceList', params, suc_cb, fail_cb) },
    // 百科:我的收藏
    getCollectList: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/myCollect', params, suc_cb, fail_cb) },
    // 百科:搜索百科
    getSearchResult: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/search', params, suc_cb, fail_cb) },
    // 百科:获取百科八字信息
    getBaiKeInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/info', params, suc_cb, fail_cb) },
    // 百科:获取百科修改历史
    getBaikeLog: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/getBaikeLog', params, suc_cb, fail_cb) },
    // 百科:增加百科起盘
    addBaiKe: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/add', params, suc_cb, fail_cb) },
    // 百科:上报浏览
    updateGlanceBaiKe: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/setGlance', params, suc_cb, fail_cb) },
    // 百科:提交百科审核
    submitBaiKeCheck: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/wantCheck', params, suc_cb, fail_cb) },
    // 百科:收藏百科
    collectBaiKe: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/collect', params, suc_cb, fail_cb) },
    // 百科:取消收藏百科
    unCollectBaiKe: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/unCollect', params, suc_cb, fail_cb) },
    // 百科:点赞
    addBaiKeLike: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/addBaikeLike', params, suc_cb, fail_cb) },
    // 百科:获取百科批盘信息
    getBaiKePiPanInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/pipan/info', params, suc_cb, fail_cb) },
    // 百科:修改百科批盘
    updateBaiKePiPanInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/pipan/update', params, suc_cb, fail_cb) },
    // 百科:提交百科批盘审核
    submitBaiKePiPanCheck: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/pipan/wantCheck', params, suc_cb, fail_cb) },
    // 百科:评论:获取评论列表
    getBaiKeReplyList: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/getReply', params, suc_cb, fail_cb) },
    // 百科:评论:评论
    addBaiKeReply: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/addReply', params, suc_cb, fail_cb) },
    // 百科:评论:删除评论
    deleteBaiKeReply: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/delReply', params, suc_cb, fail_cb) },
    // 百科:评论:举报评论
    reportBaiKeReply: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/reportReply', params, suc_cb, fail_cb) },
    // 百科:评论:点赞评论
    addBaiKeReplyLike: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/addLike', params, suc_cb, fail_cb) },
    // 百科:评论:取消点赞评论
    deleteBaiKeReplyLike: function (params, suc_cb, fail_cb) { getApi('/muhuo/baike/unLike', params, suc_cb, fail_cb) },
    // 通知模块:获取通知列表
    getMsgList: function (params, suc_cb, fail_cb) { getApi('/muhuo/getMsgList', params, suc_cb, fail_cb) },
    // 通知模块:设置消息已读
    setMsgRead: function (params, suc_cb, fail_cb) { getApi('/muhuo/setMsgRead', params, suc_cb, fail_cb) },
    // vip:免费解锁
    freeUnlock: function (params, suc_cb, fail_cb) { getApi('/muhuo/vip/freeUnlock', params, suc_cb, fail_cb) },
    // vip:限时配置
    getVipActivityInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/vip/activity', params, suc_cb, fail_cb) },
    // vip:导出发送验证码
    vipGetExportCode: function (params, suc_cb, fail_cb) { getApi('/muhuo/vip/sendSms', params, suc_cb, fail_cb) },
    // vip:提交导出
    vipSubmitExport: function (params, suc_cb, fail_cb) { getApi('/muhuo/vip/wantExport', params, suc_cb, fail_cb) },
    // vip:获取每日优惠
    getVipDayLuck: function (params, suc_cb, fail_cb) { getApi('/muhuo/vip/dayLuck', params, suc_cb, fail_cb) },
    // vip:升级vip倒计时结束
    upVipShowEnd: function (params, suc_cb, fail_cb) { getApi('/muhuo/vip/upShowEnd', params, suc_cb, fail_cb) },
    // share:设置code分享八字
    sendBaziByCodeInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/share/setCodeShare', params, suc_cb, fail_cb) },
    // share:根据code获取八字列表
    getBaziByCodeInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/share/getCodeInfo', params, suc_cb, fail_cb) },
    // share:根据code批量保存八字列表
    saveBaziByCodeInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/share/saveByCode', params, suc_cb, fail_cb) },
    // contrast:获取对比列表
    getContrastList: function (params, suc_cb, fail_cb) { getApi('/muhuo/contrast/allList', params, suc_cb, fail_cb) },
    // contrast:增加对比
    addContrast: function (params, suc_cb, fail_cb) { getApi('/muhuo/contrast/add', params, suc_cb, fail_cb) },
    // contrast:更新对比
    updateContrast: function (params, suc_cb, fail_cb) { getApi('/muhuo/contrast/update', params, suc_cb, fail_cb) },
    // contrast:删除对比
    deleteContrast: function (params, suc_cb, fail_cb) { getApi('/muhuo/contrast/del', params, suc_cb, fail_cb) },
    // gua:获取卦列表
    getGuaList: function (params, suc_cb, fail_cb) { getApi('/muhuo/gua/list', params, suc_cb, fail_cb) },
    // gua:获取最近浏览的卦列表
    getGuaRecentList: function (params, suc_cb, fail_cb) { getApi('/muhuo/gua/getRecently', params, suc_cb, fail_cb) },
    // gua:更新卦的浏览时间
    setGuaRecent: function (params, suc_cb, fail_cb) { getApi('/muhuo/gua/setRecently', params, suc_cb, fail_cb) },
    // gua:保存卦
    addGua: function (params, suc_cb, fail_cb) { getApi('/muhuo/gua/add', params, suc_cb, fail_cb) },
    // gua:更新卦
    updateGua: function (params, suc_cb, fail_cb) { getApi('/muhuo/gua/up', params, suc_cb, fail_cb) },
    // gua:通过id获取卦信息
    getGuaInfoById: function (params, suc_cb, fail_cb) { getApi('/muhuo/gua/getGuaInfo', params, suc_cb, fail_cb) },
    // gua:获取卦信息
    getGuaInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/gua/info', params, suc_cb, fail_cb) },
    // gua:删除卦
    deleteGua: function (params, suc_cb, fail_cb) { getApi('/muhuo/gua/del', params, suc_cb, fail_cb) },
    // 课程中心:一级目录
    getCourseList: function (params, suc_cb, fail_cb) { getApi('/muhuo/course/list', params, suc_cb, fail_cb) },
    // 课程中心:二级目录
    getCourseCatalogueList: function (params, suc_cb, fail_cb) { getApi('/muhuo/course/timeTable', params, suc_cb, fail_cb) },
    // 课程中心:课程播放信息
    getCourseInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/course/info', params, suc_cb, fail_cb) },
    // 课程中心:播放上报（每30秒上报一次）
    upCourseInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/course/up', params, suc_cb, fail_cb) },
    // 课程中心:历史学习
    getCourseRecordList: function (params, suc_cb, fail_cb) { getApi('/muhuo/course/history', params, suc_cb, fail_cb) },
    // 课程中心:兑换课程
    useCourseCode: function (params, suc_cb, fail_cb) { getApi('/muhuo/course/useCode', params, suc_cb, fail_cb) },
    // ds:额度配置
    getDSInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/chat/getInfo', params, suc_cb, fail_cb) },
    // ds:历史记录
    getDSMsgList: function (params, suc_cb, fail_cb) { getApi('/muhuo/chat/getBzMsgList', params, suc_cb, fail_cb) },
    // ds:推荐问题
    getDSAskList: function (params, suc_cb, fail_cb) { getApi('/muhuo/chat/getBzAskList', params, suc_cb, fail_cb) },
    // 合婚:添加合婚
    addMarriage: function (params, suc_cb, fail_cb) { getApi('/marriage/add', params, suc_cb, fail_cb) },
    // 合婚:设置验证
    setMarriageVerify: function (params, suc_cb, fail_cb) { getApi('/marriage/setVerify', params, suc_cb, fail_cb) },
    // 合婚:根据ID获取性格验证信息
    getMarriageBaseInfo: function (params, suc_cb, fail_cb) { getApi('/marriage/getBase', params, suc_cb, fail_cb) },
    // 合婚:获取合婚列表
    getMarriageList: function (params, suc_cb, fail_cb) { getApi('/marriage/getList', params, suc_cb, fail_cb) },
    // 合婚:根据id获取五行信息
    getMarriageFavorableElement: function (params, suc_cb, fail_cb) { getApi('/marriage/getFavorableElement', params, suc_cb, fail_cb) },
    // 合婚:根据id获取合婚信息
    getMarriageInfo: function (params, suc_cb, fail_cb) { getApi('/marriage/getMarriage', params, suc_cb, fail_cb) },
    // 合婚:根据分享code获取合婚信息
    getMarriageInfoByCode: function (params, suc_cb, fail_cb) { getApi('/marriage/getMarriageByCode', params, suc_cb, fail_cb) },
    // 合婚:VIP免费解锁
    vipUnlockMarriage: function (params, suc_cb, fail_cb) { getApi('/marriage/vipUnLock', params, suc_cb, fail_cb) },
    // 首页:获取首页相关信息
    getHomePageData: function (params, suc_cb, fail_cb) { getApi('/muhuo/homePage', params, suc_cb, fail_cb) },
    // 首页:获取首页类别数据
    getHomePageArticleList: function (params, suc_cb, fail_cb) { getApi('/muhuo/article/getList', params, suc_cb, fail_cb) },
    // 首页:获取单条文章、电子书、推荐阅读数据
    getHomePageArticleInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/article/getInfo', params, suc_cb, fail_cb) },
    // 五行穿衣:获取信息
    getDressPageInfo: function (params, suc_cb, fail_cb) { getApi('/muhuo/wuxing/info', params, suc_cb, fail_cb) },
}

// 获取json并返回对象
var API_JSON = {
    getJSon(url, sucCb, failCb) {
        return new Promise((resolve, reject) => {
            Vue.http.get(url).then((response) => {
                if(response.status == 200) {
                    if(sucCb && typeof(sucCb) == 'function') {
                        sucCb(response.body)
                    }
                    resolve();
                }else {
                    if(failCb && typeof(failCb) == 'function') {
                        failCb()
                    }
                    console.error("获取json失败");
                }
            }).catch((err) => {
                console.error("获取json失败::::::", err);
            });
        })
    },
    getJSonProto(url, sucCb, failCb){  
        var xml;  
        if(window.XMLHttpRequest){  
            xml = new XMLHttpRequest();  
        }else if(window.ActiveXObject){  
            xml = new window.ActiveXObject();  
        }else{  
            console.log("请升级至最新版本的浏览器");  
        }  
        if(xml != null){  
            xml.open("GET", url, true);  
            xml.send(null);  
            xml.onreadystatechange = function(){  
                if(xml.readyState == 4 && xml.status == 200){ 
                    console.log(xml.responseText);
        //          var obj = JSON.parse(xml.responseText);
        //          for (var name in obj){
        //              alert(obj[name].key);
        //          }
                }  
            };  
          
        }  
    } 
}

var API_POST = {
    // 上传文件
    uploadFile(params, sucCb, failCb) {
        var actionUrl = CONFIG.api_url + '/muhuo/file/upload?'+params.paramsStr;
        let newParams = Object.assign({}, CONFIG.platform_params);
            newParams = store.state.userData.token ? Object.assign(newParams, {
                token: store.state.userData.token
            }) : newParams;
        for (let key in newParams) {
            actionUrl += '&'+key+'='+newParams[key];
        }
        console.log('uploadFile-----', actionUrl);

        let file = params.file;
        if(!file) { return; }
        var form = new FormData();
            form.append("file", file); //第一个参数是后台读取的请求key值
            form.append("fileName", file.name);
        
        var xhr;
        if(window.XMLHttpRequest){  
            xhr = new XMLHttpRequest();  
        }else{  
            console.log("请升级至最新版本的浏览器");  
        }  
        xhr.open("POST", actionUrl);
        xhr.send(form); //发送表单数据
        xhr.onreadystatechange = function(){
            if(xhr.readyState==4 && xhr.status==200){
                var resultObj = JSON.parse(xhr.responseText);
                //处理返回的数据......
                console.log('上传图片成功-----', resultObj)
                if(sucCb && typeof(sucCb) == 'function') {
                    sucCb(resultObj.data)
                }
            }
        }

    }
}

export {
    API, API_JSON, API_POST, message
}